export function formatCurrencyInputValue(value) {
	const digitsOnly = String(value ?? '').replace(/\D/g, '');
	if (!digitsOnly) {
		return '';
	}

	const centsValue = Number(digitsOnly) / 100;
	return centsValue.toLocaleString('pt-BR', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}

export function formatCurrencyFieldValue(value) {
	if (value === undefined || value === null || value === '') {
		return '';
	}

	const parsed = parseCurrency(value);
	if (!Number.isFinite(parsed)) {
		return '';
	}

	return parsed.toLocaleString('pt-BR', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}

export function parseCurrency(value) {
	if (value === undefined || value === null || value === '') {
		return 0;
	}

	if (typeof value === 'number') {
		return Number.isFinite(value) ? value : 0;
	}

	const normalized = String(value)
		.replace(/R\$/gi, '')
		.replace(/\s/g, '')
		.trim();

	if (!normalized) {
		return 0;
	}

	const hasComma = normalized.includes(',');
	const sanitized = hasComma
		? normalized.replace(/\./g, '').replace(/,/g, '.')
		: normalized.replace(/,/g, '');

	const parsed = Number(sanitized);
	return Number.isFinite(parsed) ? parsed : 0;
}

export function hasCurrencyValue(value) {
	return String(value ?? '').replace(/\D/g, '').length > 0;
}

export function formatCurrencyDisplay(value) {
	const numericValue = Number(value || 0);
	return numericValue.toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL',
	});
}
